import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService } from '../../../../core/_base/crud';
const API_AUTH_URL = '/api/auth';
@Injectable({
  providedIn: 'root'
})
export class UserQntService {

  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) { }

  register(user: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post(`${API_AUTH_URL}/register`, user, { headers: httpHeaders });
  }

  // Login user
  login(credentials: any): Observable<any> {
    console.log('credentials', credentials);
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post(`${API_AUTH_URL}/loginQntCal`, credentials, { headers: httpHeaders });
  }
  getUserById(UserId: string): Observable<any> {
    return this.http.get<any>(`${API_AUTH_URL}/user` + `/${UserId}`);
  }

}